// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"9d4b9c63","182":"95a34fa4","327":"79cbc0f2","498":"1c56505b","551":"c59fc395","617":"a7915a6b","640":"c93105d2","950":"d62e90bd"}[chunkId] + ".chunk.js";
};